import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Scroll a bounded chat/message container to its bottom WITHOUT moving the
// window. Use this instead of `sentinel.scrollIntoView()` for chat auto-scroll:
// scrollIntoView bubbles up to every scrollable ancestor (including the page),
// which makes whole pages jump to the bottom on first load.
export function scrollBoxToBottom(el, smooth = true) {
  if (!el) return;
  try {
    el.scrollTo({ top: el.scrollHeight, behavior: smooth ? "smooth" : "auto" });
  } catch {
    el.scrollTop = el.scrollHeight;
  }
}
